import { render, staticRenderFns } from "./HowToOrder.vue?vue&type=template&id=c7e6be74&scoped=true"
import script from "./HowToOrder.vue?vue&type=script&lang=js"
export * from "./HowToOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e6be74",
  null
  
)

export default component.exports